export enum PaymentPlanEnum {
  SUBSCRIPTION = 'subscription',
  PAY_AS_YOU_GO = 'pay_as_you_go',
}
